module.exports = __webpack_public_path__ + "img/galapagos-islands.78d3e49f.png";